import { useMemo } from 'react';

import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { ShareChannel } from '../types';

import { useOnShareSuccess } from './success';
import { useGetShareText } from './text';
import { useGetShareTrackingData } from './tracking';
import { useGetShareUrl } from './url';

export function useShareOptions(): ShareActionsOptions<ShareChannel> {
	const getUrl = useGetShareUrl();
	const getText = useGetShareText();
	const getTrackingData = useGetShareTrackingData();
	const onSuccess = useOnShareSuccess();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getUrl,
			getText,
			getTrackingData,
			onSuccess,
		}),
		[getUrl, getText, getTrackingData, onSuccess],
	);
}
